import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { ManualInvoicePrimaryComponent } from 'src/app/invoice/manual-invoice/manual-invoice-primary/manual-invoice-primary.component';

@Component({
  selector: 'app-dialog-mi-preview',
  standalone: true,
  imports: [MatButtonModule, ManualInvoicePrimaryComponent, MatDialogClose],
  templateUrl: './dialog-mi-preview.component.html',
  styleUrl: './dialog-mi-preview.component.scss',
})
export class DialogMiPreviewComponent {
  readonly dialogRef = inject(MatDialogRef<DialogMiPreviewComponent>);

  onFinalizeInvoice(): void {
    this.dialogRef.close();
  }
}
